<div class="company-select">
  <div class="user-content" :class="isError ? 'is-error': ''">
    <div class="user-list">
      <span v-if="!valueName">请选择</span>
      <a-tag v-else closable color="blue" @close.prevent="removeSelected">
        <span class="value-name">{{ valueName }}</span>
      </a-tag>
    </div>
    <div @click="showModal" class="add-icon" v-if="!valueName?.length>0">
      <img src="../../assets/images/icon_add.png" />
    </div>
    <div class="disabled-cl" v-if="disabled"></div>
    <div class="zhezhao" @click="showModal" v-if="!valueName?.length>0"></div>
  </div>
</div>
